module.exports = __webpack_public_path__ + "img/cl_export_doc_3.a22b146f.png";